// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/csv_upload_history_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { CsvUploadHistory, UploadDataType, UploadResult } from "./csv_upload_history_model_pb";
import { file_bffuser_v1_csv_upload_history_model } from "./csv_upload_history_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/csv_upload_history_service.proto.
 */
export const file_bffuser_v1_csv_upload_history_service: GenFile = /*@__PURE__*/
  fileDesc("CitiZmZ1c2VyL3YxL2Nzdl91cGxvYWRfaGlzdG9yeV9zZXJ2aWNlLnByb3RvEgpiZmZ1c2VyLnYxIpADCh1MaXN0Q3N2VXBsb2FkSGlzdG9yaWVzUmVxdWVzdBI+ChBkYXRhX3R5cGVfZmlsdGVyGAEgASgOMhouYmZmdXNlci52MS5VcGxvYWREYXRhVHlwZUIIukgFggECEAESKQoSdXBsb2FkZWRfYnlfZmlsdGVyGAIgASgJQgi6SAVyAxj/AUgAiAEBEjkKDXJlc3VsdF9maWx0ZXIYAyABKA4yGC5iZmZ1c2VyLnYxLlVwbG9hZFJlc3VsdEIIukgFggECEAESLQoNdXBsb2FkZWRfZnJvbRgEIAEoCzIRLmdvb2dsZS50eXBlLkRhdGVIAYgBARIrCgt1cGxvYWRlZF90bxgFIAEoCzIRLmdvb2dsZS50eXBlLkRhdGVIAogBARIVCgRwYWdlGAYgASgFQge6SAQaAigBEh0KCXBhZ2Vfc2l6ZRgHIAEoBUIKukgHGgUY9AMoAUIVChNfdXBsb2FkZWRfYnlfZmlsdGVyQhAKDl91cGxvYWRlZF9mcm9tQg4KDF91cGxvYWRlZF90byJmCh5MaXN0Q3N2VXBsb2FkSGlzdG9yaWVzUmVzcG9uc2USLwoJaGlzdG9yaWVzGAEgAygLMhwuYmZmdXNlci52MS5Dc3ZVcGxvYWRIaXN0b3J5EhMKC3RvdGFsX2NvdW50GAIgASgFMooBChdDc3ZVcGxvYWRIaXN0b3J5U2VydmljZRJvChZMaXN0Q3N2VXBsb2FkSGlzdG9yaWVzEikuYmZmdXNlci52MS5MaXN0Q3N2VXBsb2FkSGlzdG9yaWVzUmVxdWVzdBoqLmJmZnVzZXIudjEuTGlzdENzdlVwbG9hZEhpc3Rvcmllc1Jlc3BvbnNlQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_bffuser_v1_csv_upload_history_model, file_buf_validate_validate, file_google_type_date]);

/**
 * @generated from message bffuser.v1.ListCsvUploadHistoriesRequest
 */
export type ListCsvUploadHistoriesRequest = Message<"bffuser.v1.ListCsvUploadHistoriesRequest"> & {
  /**
   * @generated from field: bffuser.v1.UploadDataType data_type_filter = 1;
   */
  dataTypeFilter: UploadDataType;

  /**
   * @generated from field: optional string uploaded_by_filter = 2;
   */
  uploadedByFilter?: string;

  /**
   * @generated from field: bffuser.v1.UploadResult result_filter = 3;
   */
  resultFilter: UploadResult;

  /**
   * @generated from field: optional google.type.Date uploaded_from = 4;
   */
  uploadedFrom?: Date;

  /**
   * @generated from field: optional google.type.Date uploaded_to = 5;
   */
  uploadedTo?: Date;

  /**
   * @generated from field: int32 page = 6;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 7;
   */
  pageSize: number;
};

/**
 * Describes the message bffuser.v1.ListCsvUploadHistoriesRequest.
 * Use `create(ListCsvUploadHistoriesRequestSchema)` to create a new message.
 */
export const ListCsvUploadHistoriesRequestSchema: GenMessage<ListCsvUploadHistoriesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_csv_upload_history_service, 0);

/**
 * @generated from message bffuser.v1.ListCsvUploadHistoriesResponse
 */
export type ListCsvUploadHistoriesResponse = Message<"bffuser.v1.ListCsvUploadHistoriesResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.CsvUploadHistory histories = 1;
   */
  histories: CsvUploadHistory[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message bffuser.v1.ListCsvUploadHistoriesResponse.
 * Use `create(ListCsvUploadHistoriesResponseSchema)` to create a new message.
 */
export const ListCsvUploadHistoriesResponseSchema: GenMessage<ListCsvUploadHistoriesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_csv_upload_history_service, 1);

/**
 * @generated from service bffuser.v1.CsvUploadHistoryService
 */
export const CsvUploadHistoryService: GenService<{
  /**
   * ListCsvUploadHistories は CSV アップロード履歴を投入日時降順で返す。
   * 期間フィルタ未指定ならデフォルトで全件表示する。
   *
   * @generated from rpc bffuser.v1.CsvUploadHistoryService.ListCsvUploadHistories
   */
  listCsvUploadHistories: {
    methodKind: "unary";
    input: typeof ListCsvUploadHistoriesRequestSchema;
    output: typeof ListCsvUploadHistoriesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_csv_upload_history_service, 0);

